import axios from 'axios';

const authApiConfig = axios.create({
    baseURL: process.env.REACT_APP_API_AUTH
    // baseURL: "http://192.168.100.34:8081/gateway/agenda/authApi"
    //baseURL: "https://reservasapi.andessaludconcepcion.cl:9090/gateway/agenda/authApi"
});

export default authApiConfig;